import React from 'react';
import './card-tile.scss';

const CardTile = (props) => {
    return (
        <a href={props.url} target='_blank' rel="noopener noreferrer">
            <div className='card-tile'>
                <div className="card-tile__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="44.301" height="60" viewBox="0 0 44.301 60">
                        <path id="Path_15181" data-name="Path 15181" d="M227.612,76.885h-20.14a7.444,7.444,0,0,0-7.445,7.445V129.44a7.444,7.444,0,0,0,7.445,7.445h29.412a7.444,7.444,0,0,0,7.445-7.445V93.6a.827.827,0,0,0-.24-.587l-15.9-15.906a.827.827,0,0,0-.579-.223Zm.827,2.821,13.069,13.069H229.266a.827.827,0,0,1-.827-.827Zm8.444,55.525H207.472a5.79,5.79,0,0,1-5.79-5.79V84.331a5.79,5.79,0,0,1,5.79-5.79h19.313V91.948a2.482,2.482,0,0,0,2.482,2.482h13.408v35.012a5.79,5.79,0,0,1-5.79,5.79Z" transform="translate(-200.027 -76.885)" fill="#d93f04" />
                    </svg>
                </div>
                <p>
                    {props.type}
                    {/* <strong> {props.title}</strong> */}

                    <strong dangerouslySetInnerHTML={{ __html: props.title }}></strong>
                </p>

                
            </div>
        </a>
    )
}

export default CardTile